import { Form, Mentions, Select } from 'antd'
import { useMemo } from 'react'

export default function AppointmentCreate({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item
        label="ID do Paciente (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'paciente_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Selecione o parâmetro que contém o ID numérico do paciente no Feegow (ex: 12345). O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" />
      </Form.Item>
      <Form.Item
        label="ID do Profissional (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'profissional_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Selecione o parâmetro que contém o ID numérico do profissional no Feegow. O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" />
      </Form.Item>
      <Form.Item
        label="Data"
        name={[fieldName, 'action', 'data', 'data']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Formato YYYY-MM-DD (ex: 2026-03-15). O parâmetro deve fornecer a data neste formato."
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="Horário"
        name={[fieldName, 'action', 'data', 'horario']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Formato HH:MM (ex: 14:30). O serviço acrescenta os segundos automaticamente."
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="ID da Unidade/Local (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'local_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Selecione o parâmetro que contém o ID numérico da unidade/local no Feegow. O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" />
      </Form.Item>
      <Form.Item
        label="ID do Procedimento (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'procedimento_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Selecione o parâmetro que contém o ID numérico do procedimento no Feegow. O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" />
      </Form.Item>
      <Form.Item
        label="ID da Especialidade (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'especialidade_id']}
        tooltip="Selecione o parâmetro que contém o ID numérico da especialidade no Feegow (ex: 227). O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" allowClear />
      </Form.Item>
      <Form.Item
        label="ID do Convênio (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'convenio_id']}
        tooltip="ID numérico do convênio (campo convenio_id retornado por INSURANCE_LIST). O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" allowClear />
      </Form.Item>
      <Form.Item
        label="ID do Plano do Convênio (número inteiro Feegow)"
        name={[fieldName, 'action', 'data', 'plano']}
        tooltip="ID numérico do plano dentro do convênio (campo id dos planos retornados por INSURANCE_LIST). O parâmetro deve ser do tipo número."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" allowClear />
      </Form.Item>
      <Form.Item
        label="Valor do Agendamento (número inteiro)"
        name={[fieldName, 'action', 'data', 'valor']}
        tooltip="Valor do agendamento em centavos (número inteiro)."
      >
        <Select options={available} placeholder="Selecione um parâmetro numérico" allowClear />
      </Form.Item>
      <Form.Item label="ID do Canal" name={[fieldName, 'action', 'data', 'canal_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="Notas" name={[fieldName, 'action', 'data', 'notas']}>
        <Mentions prefix="$" split="" options={available} placeholder="Ex: Agendado via WhatsApp por $nome" />
      </Form.Item>
    </>
  )
}
